var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",style:({
    backgroundColor: _vm.bus.color_code,
    color: _vm.invertHex(_vm.bus.color_code),
    })},[_vm._v(" "+_vm._s(_vm.bus.name))])}
var staticRenderFns = []

export { render, staticRenderFns }